import dayjs from 'dayjs';
import type { DashboardPeriod } from '../PeriodTabs';

export interface Donem {
  bas: string;   // YYYY-MM-DD
  bit: string;   // YYYY-MM-DD
  tekGun: boolean;
}

/**
 * PeriodTabs secimini rapor parametrelerine cevirir.
 * 'ozel' burada YALNIZ ilk deger uretir; gercek aralik ekrandaki tarih
 * secicisinden gelir (bkz. SatisAnaliz).
 */
export function donemHesapla(p: DashboardPeriod): Donem {
  const bugun = dayjs();
  switch (p) {
    case 'gunluk':
      return { bas: bugun.format('YYYY-MM-DD'), bit: bugun.format('YYYY-MM-DD'), tekGun: true };
    case 'dun': {
      const d = bugun.subtract(1, 'day');
      return { bas: d.format('YYYY-MM-DD'), bit: d.format('YYYY-MM-DD'), tekGun: true };
    }
    case 'yillik':
      return {
        bas: bugun.startOf('year').format('YYYY-MM-DD'),
        bit: bugun.format('YYYY-MM-DD'),
        tekGun: false,
      };
    case 'aylik':
    case 'ozel':
    default:
      return {
        bas: bugun.startOf('month').format('YYYY-MM-DD'),
        bit: bugun.format('YYYY-MM-DD'),
        tekGun: false,
      };
  }
}

/**
 * `donem` icin ekranda gosterilen, gercekten kullanici degerine sahip metin
 * (yalniz test icin var olan gizli bir alan DEGIL — PeriodTabs'in yanindaki
 * gorunur etiket). DD.MM.YYYY seciliyor: RangePicker'in kendi `format`'iyla
 * ayni, locale'e bagli ay adi kullanmadigi icin dayjs locale ayarlanmamis
 * bir baglamda bile dogru basar.
 */
export function donemAraligiMetni(d: Donem): string {
  const bas = dayjs(d.bas).format('DD.MM.YYYY');
  if (d.tekGun) return bas;
  const bit = dayjs(d.bit).format('DD.MM.YYYY');
  return `${bas} – ${bit}`;
}


/**
 * Secilen donemle AYNI UZUNLUKTA, hemen ONCESINDEKI (ortusmeyen) pencereyi
 * hesaplar. `012` "Donemsel Karsilastirma" raporunun kullandigi tanimla
 * AYNI: uzunluk = bit - bas + 1 (kapsayici gun sayisi); onceki pencere
 * `bas - uzunluk` gununden `bas - 1` gunune kadar surer. Genel bir yardimci
 * - Task 9 (marj erimesi) burada kullaniyor, baska bloklar da isteyebilir.
 */
export function oncekiDonemHesapla(d: Pick<Donem, 'bas' | 'bit'>): { bas: string; bit: string } {
  const bas = dayjs(d.bas);
  const bit = dayjs(d.bit);
  const uzunlukGun = bit.diff(bas, 'day') + 1;
  const oncekiBit = bas.subtract(1, 'day');
  const oncekiBas = oncekiBit.subtract(uzunlukGun - 1, 'day');
  return {
    bas: oncekiBas.format('YYYY-MM-DD'),
    bit: oncekiBit.format('YYYY-MM-DD'),
  };
}
